var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtendaGologo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491.2 214.4",
    style: {
      enableBackground: "new 0 0 491.2 214.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4CD2;}\n\t.st1{fill:#3C3364;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GO_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "extenda_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "GO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429,142.8c-19.6,0-35.6-16-35.6-35.6s16-35.6,35.6-35.6c19.6,0,35.6,16,35.6,35.6S448.7,142.8,429,142.8z  M429,87c-11.1,0-20.2,9.1-20.2,20.2s9,20.2,20.2,20.2c11.1,0,20.2-9.1,20.2-20.2S440.1,87,429,87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352.5,
    y: 99.5,
    className: "st0",
    width: 74.9,
    height: 15.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.1,107l-15.7,0.3c-0.1,11-9,19.9-20,19.9c-11,0-20-9-20-20s9-20.1,20-20.1c6.3,0,11.9,2.9,15.6,7.5 l7.7-14.2c-2-1.9-2.3-2.2-4.6-3.6l-9.6,12.6l9.6-12.6c-5.5-3.4-11.9-5.3-18.7-5.3c-19.7,0-35.7,16-35.7,35.7s16,35.7,35.7,35.7 s35.7-16,35.7-35.7C394.2,107.1,394.1,107.1,394.1,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.7,107.2C404.7,107.2,404.8,107.2,404.7,107.2L404.7,107.2L404.7,107.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "444.3,107.2 426.6,121.1 426.6,93.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "extenda_00000102504827159724009490000011753001300523059133_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.5,109.5V97.8H124V85h-12v5.6c0,4.1-2.2,7.1-6.8,7.1H87.7l8.3,11.7h14.8v18.8c0,8.7,5.6,14.1,14.6,14.1 c4.2,0,6.4-1,7-1.2v-11.1c-0.8,0.2-2.1,0.4-3.5,0.4c-2.9,0-4.8-1-4.8-4.6v-16.4L132.5,109.5L132.5,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,129c-2.1,7.6-9.1,13.9-20.2,13.9c-12.1,0-22.8-8.6-22.8-23.4c0-14.1,10.5-23.1,21.9-23.1 c13.6,0,22,8.4,22,22.5c0,1.8-0.2,3.9-0.3,4.1H39.6c0.3,4.9,4.8,8.5,10,8.5c4.8,0,7.6-2.3,8.8-5.7L69.6,129z M57.4,114.5 c-0.2-3.3-2.5-7.4-8.8-7.4c-5.6,0-8.5,4.1-8.7,7.4H57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.1,129c-2.1,7.6-9.1,13.9-20.2,13.9c-12.1,0-22.8-8.6-22.8-23.4c0-14.1,10.5-23.1,21.9-23.1 c13.6,0,21.9,8.4,21.9,22.5c0,1.8-0.2,3.9-0.3,4.1h-30.5c0.3,4.9,4.8,8.5,10,8.5c4.9,0,7.6-2.3,8.8-5.7L176.1,129z M163.9,114.5 c-0.2-3.3-2.5-7.4-8.8-7.4c-5.6,0-8.5,4.1-8.7,7.4H163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.6,141.6h-13.4V97.8h13v5c2.4-4.1,7.8-6.2,12.2-6.2c11,0,15.9,7.8,15.9,17.5v27.5H208v-25.2 c0-4.3-2.3-7.6-7.1-7.6c-4.4,0-7.2,3.3-7.2,7.7L193.6,141.6L193.6,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.5,133.8c0,4,0.3,6.9,0.4,7.8h-12.9c-0.1-0.5-0.4-2.5-0.4-4.2c-2,3-6.4,5.2-11.7,5.2 c-12.3,0-21.7-9.5-21.7-23c0-13,8.8-22.8,21.2-22.8c7.5,0,10.7,2.8,11.8,4.5V85h13.2L270.5,133.8L270.5,133.8z M247.6,130.6 c5.2,0,9.9-3.7,9.9-10.9c0-7.3-4.7-10.8-9.9-10.8s-9.9,3.5-9.9,10.8C237.7,126.9,242.3,130.6,247.6,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.1,116.3l10.3-1.6c2.4-0.3,3.2-1.5,3.2-3c0-2.6-2.2-4.8-6.4-4.8c-4.7,0-7.2,3.2-7.5,6.4l-11.6-2.4 c0.5-6.3,6.4-14.5,19.2-14.5c14.2,0,19.4,7.9,19.4,16.9v21.4c0,3.4,0.4,6.4,0.5,6.8h-12.1c-0.1-0.4-0.4-1.9-0.4-4.9 c-2.3,3.7-6.5,6.2-12.3,6.2c-9.6,0-15.2-6.4-15.2-13.3C274.2,121.8,279.9,117.4,287.1,116.3z M300.6,124.4v-1.9l-8.3,1.3 c-2.8,0.4-4.9,1.8-4.9,4.9c0,2.3,1.5,4.5,5.2,4.5C296.5,133.1,300.6,131.2,300.6,124.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,119.8l-15.3-22h15.8c0,0,26,36.8,31,43.8H97.7l-8.1-12.3c-2.4,3.5-5.6,8.7-8,12.3H66.8L81.9,119.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendaGologo);
export default __webpack_public_path__ + "static/media/extenda-go.logo.a371a147571b7504a39ee78b670913f2.svg";
export { ForwardRef as ReactComponent };